import { ordermanagerUrl } from "../resources";
import common from '../common/common.js';

async function getCurrentOrders(restaurantId) {
    let data = null;

    let url = `${ordermanagerUrl}/GetCurrentOrdersByRestaurant/${restaurantId}`;

    await common.getDataWithToken(url)
                .then(response => data = response);
    
    return data;
}

async function getCurrentWaitingTime(restaurantId) {
    let data = null;

    let url = `${ordermanagerUrl}/GetCurrentWaitingTimeByRestaurant/${restaurantId}`;

    await common.getDataWithToken(url)
                .then(response => data = response);
    
    return data;
}

async function getOrderManagerState(restaurantId) {
    let data = null;
    
    let url = `${ordermanagerUrl}/GetOrderManagerStateByRestaurant/${restaurantId}`;

    await common.getDataWithToken(url)
                .then(res => data = res);
    
    return data;

}

export default {
    getCurrentOrders,
    getCurrentWaitingTime,
    getOrderManagerState
}